import { render } from "./Panden.vue?vue&type=template&id=4da6e65c"
import script from "./Panden.vue?vue&type=script&lang=js"
export * from "./Panden.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__